var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.707.295l7 7.002a.98.98 0 01.294.656L20 8.004v3.998a1 1 0 11-2 0V9.004h-6a1 1 0 01-1-1V2.002H4v20h7a1 1 0 010 2H4c-1.101 0-2-.898-2-2v-20c0-1.102.899-2 2-2h7.942a.978.978 0 01.765.293zm4.294 14.707a4.002 4.002 0 013.446 6.03l1.26 1.263a1 1 0 01-1.414 1.414l-1.262-1.26a4 4 0 11-2.03-7.447zm0 2a2 2 0 101.403 3.424l.01-.01.01-.01A2.002 2.002 0 0017 17.002zM13 3.417v3.587h3.586L13 3.417z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconPreview;